module.exports = __webpack_public_path__ + "static/fix-popular-brands-in-footer-ver4-2-de3aec9ef07bc6355c528b47fcb631b9.jpg";